import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { ContentLayoutComponent } from './layout/content-layout/content-layout.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { OnlyLoggedInUsersGuard } from './shared/guards/OnlyLoggedInUsersGuard';

const routes: Routes = [
  { path: 'pageNotFound', component: PageNotFoundComponent },
  { path: 'pageNotFound', redirectTo: '' },
  {
    path: 'auth',
    loadChildren: () => import('./modules/customer-auth/customer-auth.module').then(m => m.CustomerAuthModule)
  },
  {
    path: 'dashboard',
    canActivate: [OnlyLoggedInUsersGuard],
    loadChildren: () => import('./modules/customer-dashboard/customer-dashboard.module').then(m => m.CustomerDashboardModule)
  },
  {
    path: 'ownership-transfer',
    canActivate: [OnlyLoggedInUsersGuard],
    loadChildren: () => import('./modules/ownership-transfer/ownership-transfer.module').then(m => m.OwnershipTransferModule)
  },
  {
    path: 'device-mapping',
    canActivate: [OnlyLoggedInUsersGuard],
    loadChildren: () => import('./modules/device-mapping/device-mapping.module').then(m => m.DeviceMappingModule)
  },{
    path: 'search-old-vin',
    canActivate: [OnlyLoggedInUsersGuard],
    loadChildren: () => import('./modules/search-old-vin/search-old-vin.module').then(m => m.SearchOldVinModule)
  },
  {
    path: 'search-letData',
    canActivate: [OnlyLoggedInUsersGuard],
    loadChildren: () => import('./modules/search-letData/search-letData.module').then(m => m.SearchLetDataModule)
  },
  {
    path: 'delete-guestUser',
    canActivate: [OnlyLoggedInUsersGuard],
    loadChildren: () => import('./modules/delete-guestUser/delete-guestUser.module').then(m => m.DeleteGuestUserModule)
  },
  {
    path: '',
    redirectTo: 'auth',
    pathMatch: 'full'
  },
  {
    path: 'shareSvtLocation',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/share-svt-location/share-my-location/share-svt-location.module').then(m => m.ShareSvtLocationModule)
      }
    ]
  },
  { path: '**', redirectTo: 'auth' }
  // // {
  // //   path: '',
  // //   redirectTo: 'pageNotFound',
  // //   pathMatch: 'full'
  // // },
  // {
  //   path: '',
  //   component: ContentLayoutComponent,
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: () =>
  //         import('../app/modules/customer-auth/customer-auth.module').then(m => m.CustomerAuthModule)
  //     },
  //     {
  //       path: 'login',
  //       loadChildren: () =>
  //         import('../app/modules/customer-auth/customer-auth.module').then(m => m.CustomerAuthModule)
  //     },

  //   ]
  // },
  // {
  //   path: '',
  //   component: ContentLayoutComponent,
  //   canActivate: [OnlyLoggedInUsersGuard],
  //   children: [
  //     {
  //       path: 'dashboard',
  //       loadChildren: () =>
  //         import('../app/modules/customer-dashboard/customer-dashboard.module').then(m => m.CustomerDashboardModule)
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   children: [
  //     {
  //       path: 'shareSvtLocation',
  //       loadChildren: () =>
  //         import('./modules/share-svt-location/share-my-location/share-svt-location.module').then(m => m.ShareSvtLocationModule)
  //     }
  //   ]
  // },
  // { path: '**', redirectTo: 'pageNotFound' }

];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
